import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./SelectInput.vue?vue&type=style&index=1&id=10648c7d&lang=scss"

const __exports__ = script;

export default __exports__